import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { PolicyTrackerData } from "../policy-tracker.interfaces";

interface CoverageLike {
  title?: string;
  type?: string;
  limit?: number;
  amount?: number;
}

@Component({
  selector: "app-policy-tracker-info",
  imports: [CommonModule],
  templateUrl: "./policy-tracker-info.component.html",
  styleUrls: ["./policy-tracker-info.component.scss"],
})
export class PolicyTrackerInfoComponent {
  @Input() policy!: PolicyTrackerData;

  get insuredAddress(): string {
    return this.policy.latestSubmittedRevision?.address || this.policy.address;
  }

  // FE-280: the additional interest's OWN address — must never fall back to
  // insuredAddress above (that was the bug: both rows showed the insured's address).
  get additionalInterestAddresses(): string[] {
    return (this.policy.additionalInterests || [])
      .map((entry) => entry?.address?.trim())
      .filter((address): address is string => !!address);
  }

  get effectiveDate(): string {
    return this.policy.latestSubmittedRevision?.revision?.effective_date || this.policy.effectiveDate;
  }

  get expirationDate(): string {
    return this.policy.latestSubmittedRevision?.revision?.expiration_date || this.policy.expirationDate;
  }

  get coverages(): CoverageLike[] {
    const revisionCoverages = this.policy.latestSubmittedRevision?.revision?.policy_coverages as CoverageLike[] | undefined;
    return (revisionCoverages?.length ? revisionCoverages : this.policy.coverages) || [];
  }

  coverageKind(coverage: CoverageLike): "liability" | "contents" | "other" {
    const title = (coverage.title || coverage.type || "").toLowerCase();
    if (title.includes("liability")) return "liability";
    if (title.includes("content") || title.includes("property")) return "contents";
    return "other";
  }

  coverageTitle(coverage: CoverageLike): string {
    return coverage.title || coverage.type || "Coverage";
  }

  coverageAmount(coverage: CoverageLike): number {
    return (coverage.limit ?? coverage.amount ?? 0) / 100;
  }
}
